import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["defaultValue"];
import React, { forwardRef, useRef } from 'react';
import { useMergeRefs } from '@tui-react/core';
import { useFocusedState } from './useFocusedState';
import { useValueState } from './useValueState';
export const withValueInputState = (Component, {
  emptyValue
}) => /*#__PURE__*/forwardRef((props, forwardedRef) => {
  const restProps = _objectWithoutPropertiesLoose(props, _excluded);
  const innerRef = useRef(null);
  const ref = useMergeRefs([forwardedRef, innerRef]);
  const propsWithState = _extends({}, restProps, useValueState(_extends({}, props, {
    emptyValue
  }), innerRef), useFocusedState(props));
  return /*#__PURE__*/React.createElement(Component, _extends({}, propsWithState, {
    ref
  }));
});